import { IReactQuillDelta } from '../APIPackage/KnmModule/interfaces/IReactQuillDelta';

export const removeTrailingNewline = (delta: IReactQuillDelta) => {
  if (!delta.ops || delta.ops.length === 0) {
    return delta;
  }

  // Создаем копию delta чтобы не мутировать исходный объект
  const cleanedDelta = JSON.parse(JSON.stringify(delta));

  // Получаем последнюю операцию
  const lastOp = cleanedDelta.ops[cleanedDelta.ops.length - 1];

  // Если последняя операция содержит insert с текстом и он заканчивается на \n
  if (lastOp.insert && typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n')) {
    // Убираем последний \n
    lastOp.insert = lastOp.insert.slice(0, -1);

    // Если после удаления \n строка стала пустой, удаляем всю операцию
    if (lastOp.insert === '') {
      cleanedDelta.ops.pop();
    }
  }

  return cleanedDelta;
};
